<app-normal-navbar></app-normal-navbar>
<app-season-details></app-season-details>
<app-footer></app-footer>
